import { render, staticRenderFns } from "./PublicationDataCollectionsList.vue?vue&type=template&id=833a1412&"
import script from "./PublicationDataCollectionsList.vue?vue&type=script&lang=js&"
export * from "./PublicationDataCollectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports